import { Stack, Typography, Box } from '@mui/material';
import {
  CopyTestLinkButton,
  ExpandedDetailsSection,
  Flex,
  Loading,
  TestLineageNavButton,
} from '../../../components';
import { TestInvocation, TestRun } from '../../../types';
import OpenTestResultsButton from './OpenTestResultsButton';
import TestRunsChart from './TestRunsChart';

type Props = {
  rowData: TestRun;
  invocations: TestInvocation[];
  isFetching?: boolean;
  onOpenSnackbar?: (message: string) => void;
};

const TestRunsExpandedRow = ({
  rowData,
  invocations,
  isFetching,
  onOpenSnackbar,
}: Props) =>
  isFetching ? (
    <Loading />
  ) : (
    <Stack sx={{ gap: 2 }}>
      <Flex sx={{ justifyContent: 'space-between' }}>
        {rowData?.metadata.test_type === 'dbt_test' ? (
          <Typography sx={{ fontWeight: 500 }}>
            Test execution results and failed results count
          </Typography>
        ) : (
          <Box />
        )}
        <Flex gap={1} sx={{ alignItems: 'center' }}>
          <OpenTestResultsButton
            urlParam={rowData.metadata.elementary_unique_id}
          />
          {!!rowData.metadata.model_unique_id && (
            <TestLineageNavButton
              modelId={rowData.metadata.model_unique_id}
              testName={rowData.metadata.test_name}
            />
          )}
          <CopyTestLinkButton
            testId={rowData.metadata.elementary_unique_id}
            onOpenSnackbar={onOpenSnackbar}
          />
        </Flex>
      </Flex>
      <TestRunsChart data={invocations} type={rowData?.metadata.test_type} />
      <ExpandedDetailsSection data={rowData} onOpenSnackbar={onOpenSnackbar} />
    </Stack>
  );

export default TestRunsExpandedRow;
